<template>
    <!-- Auth redesign — сила пароля + чек-лист требований (макет Claude Design).
         Единый алгоритм для reset и регистрации (#3/#4). value — текущий пароль.
         emit update:valid — выполнены все требования. -->
    <div class="pwm">
        <template v-if="this.value && this.value.length">
            <div class="strength">
                <span v-for="i in 4" :key="i" class="seg" :style="i <= this.score ? { background: this.st.color } : {}"></span>
            </div>
            <div class="strength-row">
                <span class="strength-label" :style="{ color: this.st.color }">{{ this.st.label }}</span>
            </div>
        </template>
        <div class="req-list">
            <div v-for="r in this.reqs" :key="r.id" class="req-item" :class="{ met: r.ok }">
                <span class="req-mark"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg></span>{{ r.label }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: { type: String, default: '' },
    },
    emits: ['update:valid'],
    computed: {
        reqs() {
            const p = this.value || '';
            return [
                { id: 'len', label: this.$t('views.Login.52'), ok: p.length >= 8 },
                { id: 'case', label: this.$t('views.Login.53'), ok: /[a-z]/.test(p) && /[A-Z]/.test(p) },
                { id: 'num', label: this.$t('views.Login.54'), ok: /\d/.test(p) },
                { id: 'sym', label: this.$t('views.Login.55'), ok: /[^\w\s]/.test(p) },
            ];
        },
        passed() { return this.reqs.filter((r) => r.ok).length; },
        score() {
            const p = this.value || '';
            if (!p.length) return 0;
            let s = 0;
            if (p.length >= 8) s++;
            if (p.length >= 12) s++;
            if (/[a-z]/.test(p) && /[A-Z]/.test(p)) s++;
            if (/\d/.test(p)) s++;
            if (/[^\w\s]/.test(p)) s++;
            return Math.min(s, 4);
        },
        st() {
            const levels = [
                { label: this.$t('views.Login.56'), color: 'var(--danger)' },
                { label: this.$t('views.Login.57'), color: '#E0883A' },
                { label: this.$t('views.Login.58'), color: '#E0B83A' },
                { label: this.$t('views.Login.59'), color: '#3FA86B' },
                { label: this.$t('views.Login.60'), color: 'var(--ok)' },
            ];
            return levels[this.score];
        },
        allMet() { return this.passed === this.reqs.length; },
    },
    watch: {
        allMet: { immediate: true, handler(v) { this.$emit('update:valid', v); } },
    },
};
</script>

<style lang="scss" scoped>
.pwm { margin-top: 10px; }
.strength { display: flex; gap: 6px; }
.strength .seg { height: 5px; flex: 1; border-radius: 3px; background: var(--line); transition: background .25s ease; }
.strength-row { display: flex; justify-content: space-between; align-items: baseline; margin-top: 8px; }
.strength-label { font-size: 12px; font-weight: 600; }

.req-list { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 16px; margin-top: 14px; }
.req-item { display: flex; align-items: center; gap: 8px; font-size: 12.5px; color: var(--ink-soft); transition: color .2s ease; }
.req-item .req-mark {
    width: 17px; height: 17px; border-radius: 50%; flex: none; display: grid; place-items: center;
    border: 1.5px solid var(--line-strong); color: transparent; transition: all .2s ease;
}
.req-item .req-mark svg { width: 10px; height: 10px; }
.req-item.met { color: var(--ink); }
.req-item.met .req-mark { background: var(--ok); border-color: var(--ok); color: #fff; }
@media (max-width: 540px) { .req-list { grid-template-columns: 1fr; } }
</style>
